import React from 'react';
import './TutorMessage.css'
function TutorMessage({message,orgName, orgLogo}) {
    return (
        <div className="tutor-message-container">
            <div className="tutor-message-box">
                <div className="content-box">
                    <h1>A special <span>message from your Tutor</span></h1>
                    <p>{message}</p>
                    <div className="content-icon">
                        <img src={orgLogo} alt="logo"/>
                        <h4>{orgName}</h4>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TutorMessage;
